import { render, staticRenderFns } from "./RedefineSenha.vue?vue&type=template&id=aade58c0"
import script from "./RedefineSenha.vue?vue&type=script&lang=js"
export * from "./RedefineSenha.vue?vue&type=script&lang=js"
import style0 from "./RedefineSenha.vue?vue&type=style&index=0&id=aade58c0&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports